/**
 * @fileoverview GetDashboardStatistic
 * @exports GetDashboardStatistic
 * @date 2022-08-23
 * @version 1.0 
 * @author Combes Hugo
 */

/*Import necessaries librairies*/
import React from "react";
import _ from 'lodash';

import { Divider } from '@mantine/core';
import { Grid } from "@mantine/core";
import { Text, Paper } from '@mantine/core';
import { Progress, Tooltip} from '@mantine/core';
import { Switch, Space } from '@mantine/core';
//import { Affix, rem } from '@mantine/core';
import { Center } from "@mantine/core";
import { Radar } from 'react-chartjs-2';
import ReactDOM from 'react-dom';
import { ActionIcon } from '@mantine/core';
import { Graph } from "react-d3-graph";
import { IconArrowsMaximize } from '@tabler/icons';

import BarChart from "./chart/BarChart";
import BarChartExperience from "./chart/BarChartExperience";
import BarGender from "./chart/BarGender";
import MapChart from "./chart/MapChart";
import PieChart from "./chart/PieChart";
import LineChart from "./chart/LineChart";
import ClientChart from "./chart/ClientChart";
import { Chart, RadialLinearScale } from 'chart.js';
import diagramV from "../../assets/images/diagramV.svg"


// Register the radialLinear scale component
Chart.register(RadialLinearScale);

const PieChartOptionsDomain = {
  title: {
    display: true,
    position: "right",
    text: "Nombre d'alert par Niveau",
    align: "center",
    padding: {
      top: 10,
      bottom: 10,
    },
  }
}

const imageStyle = {
  position: "relative",
};

const textOverlayStyle = {
  position: "absolute",
  fontSize: "14px",
  color: "black",
};

const textPositions = [
  { x: 30, y: 43 },
  { x: 55, y: 106 },
  { x: 80, y: 176 },
  { x: 105, y: 250 },
  { x: 150, y: 320 },
  { x: 235, y: 250 },
  { x: 260, y: 176 },
  { x: 285, y: 106 },
  { x: 310, y: 43}
];

export class GetDashboardStatistic extends React.Component {
  constructor(props) {
    super(props);
    this.progressRef = React.createRef();
    this.graphRef = React.createRef();
    this.state = {
      technicalSkillSelected: "",
      operationalSkillSelected : "",
      graphicType:"Somme",
      mapType:"Europe",
      graphicIsCompacted:true,
      openClientBox:false,
      value:"Competence",
      redrawGraph:false,
      typologyYear:4,
      typologyYear2:0,
      zoomIsNear:0.65,
      graphConsultantOverTimeSize:12,
      switchBarGraphMode:false
    };
  }


  componentDidUpdate(prevProps) {
    /*const tElements = d3.selectAll("#nodeGraph");
    const tCount = tElements.size();
    if (prevProps.datatochart !== this.props.datatochart ) {
      d3.selectAll("#nodeGraph").remove()
      this.setState({ redrawGraph : true })
    }
    if (tCount>1){
      d3.selectAll("#nodeGraph").remove()
      this.setState({ redrawGraph : true })
    }
    if (prevProps.value !== this.props.value) {
      this.calculateLabelPosition();
    }*/
  }


  componentDidMount() {
    this.calculateLabelPosition();
  }



  onZoomChange = (previousZoom, newZoom) => {
    if (newZoom > 1.15) {
      this.setState({ zoomIsNear : newZoom })
    }
  };

  calculateLabelPosition() {
    const width = this.progressRef.current.getBoundingClientRect().width;
    const position = (this.props.value / 100) * width;
    this.setState({ labelPosition: position });
  }




    render() {

    let _this = this


    const { value, label, ...props } = this.props;

    let continent = [0,1,2,3];

    const myConfig = {
      nodeHighlightBehavior: true,
      highlightOpacity:0.2,
      linkHighlightBehavior:true,
      //collapsible:true,
      //automaticRearrangeAfterDropNode:true,
      initialZoom:this.state.zoomIsNear,
      node: {
        color: "lightgreen",
        size: 120,
        highlightStrokeColor: "blue",
        labelProperty:"label",
        renderLabel: true,
        opacity: 1,
      },
      link: {
        highlightColor: "lightblue",
        renderLabel:true,
        opacity: 0.75,
        type:"CURVE_SMOOTH",
      },
    };



      function getConsultantTotal(consultants){  
        return((consultants).length)
      }

      function reFormatDate(date){
        return(date[6]+date[7]+date[8]+date[9]+"-"+date[3]+date[4])
      }

      function returnEndDate(date){
        if(date && date.length>9){
          return(reFormatDate(date))
        } else{
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = (currentDate.getMonth() + 2).toString().padStart(2, '0');
          const formattedDate = `${year}-${month}`;
          return(formattedDate)
        }
      }


      function getTop10ClientCoordinate(consultants,mode){
        let allClient = []
        let allClientDate = []
        let allClientDateEnd = []
        for(let i = 0; i < consultants.length; i++){
          Object.keys(consultants[i].projects).forEach((key) => {
            if (consultants[i].projects[key].content.information && consultants[i].projects[key].content.information["start-date"]){
              allClient.push(consultants[i].projects[key].content.client.level_1.value);
              allClientDate.push( reFormatDate(consultants[i].projects[key].content.information["start-date"])  );
              allClientDateEnd.push(returnEndDate(consultants[i].projects[key].content.information["end-date"]));
            }
            return null
        })
        }
        const uniqueClient = allClient.filter((val, id) => {
          return allClient.indexOf(val) === id;
        });
        const uniqueClientCount = new Array(uniqueClient.length).fill(0)
        for (let x = 0; x < uniqueClient.length; x++){
          uniqueClientCount[x] = allClient.filter(item => item === uniqueClient[x]).length;
        }
        const mapOfClient = new Map();
        for (let i = 0; i < uniqueClient.length; i++) {
          mapOfClient.set(uniqueClient[i], uniqueClientCount[i]);
        }
        const mapOfClientSorted = new Map([...mapOfClient.entries()].sort((a, b) => b[1] - a[1]));
        const top10ClientName = [...mapOfClientSorted.keys()].slice(0, 10);
        let uniqueClientDate =  allClientDate.filter((val, id) => {
          return allClientDate.indexOf(val) === id;
        });
        uniqueClientDate = uniqueClientDate.sort((a,b) => a.localeCompare(b,undefined,{numeric: true}))

        //création matrice
        let coordinates = [[],[],[],[],[],[],[],[],[],[]]
        for (let t = 0; t < uniqueClientDate.length; t++){
          for (let i = 0; i < coordinates.length; i++){
            coordinates[i].push(0)
          }
        }
        //remplissage de la matrice avec coordonnées
        for (let x = 0; x < allClient.length; x++){
          if(top10ClientName.indexOf(allClient[x]) !== -1){ 
            let j = uniqueClientDate.indexOf(allClientDate[x])
            coordinates[top10ClientName.indexOf(allClient[x])][j] = coordinates[top10ClientName.indexOf(allClient[x])][j] + 1  //on ajoute 1 client au moins de départ du projet
            //maintenant si on veut l'intervalle, on doit ajouter 1 par mois jusqu'atteindre le moins de fin du projet
            const date1 = new Date(allClientDate[x]);
            const date2 = new Date(allClientDateEnd[x]);
            let interval = (date2.getFullYear() - date1.getFullYear()) * 12 + (date2.getMonth() - date1.getMonth());
            if (interval>0){
              for(let i = 1; i < interval; i++){
                coordinates[top10ClientName.indexOf(allClient[x])][j+i] = coordinates[top10ClientName.indexOf(allClient[x])][j+i] + 1
              }
            }
          }
        }
        // !!!
        // end for normal value, now we gonna modify the data to make them more compact
        uniqueClientDate = uniqueClientDate.filter((element, index) => index % 2 === 0)
        for(let i = 0; i < coordinates.length; i++){
          const mappedCompactedCoordinates = coordinates[i].map((element, index) => {
            if (index % 2 === 1) { // if the index is odd
              return element; // return the element unchanged
            } else { // if the index is even
              if(index === 0) { return element }
              return coordinates[i][index - 1] + element; // return the sum of the element and its previous element
            }
          }); // [2, 3, 3, 8, 5]
          coordinates[i] = mappedCompactedCoordinates.filter((element, index) => index % 2 === 0); // new array with only even rank elements
        }
        //
        if(mode==="Normal"){
          return([top10ClientName,uniqueClientDate,coordinates])
        }
        if(mode==="Table"){
          return([uniqueClient,uniqueClientCount])
        }
        /* stop here to have top 10 coordinate for each individual month
        now we gonna, do the somme for each value */
        for(let i = 0; i < uniqueClientDate.length; i++){
          coordinates[0][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] + coordinates[5][i] + coordinates[4][i] + coordinates[3][i] + coordinates[2][i] + coordinates[1][i] + coordinates[0][i]
          coordinates[1][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] + coordinates[5][i] + coordinates[4][i] + coordinates[3][i] + coordinates[2][i] + coordinates[1][i]
          coordinates[2][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] + coordinates[5][i] + coordinates[4][i] + coordinates[3][i] + coordinates[2][i]
          coordinates[3][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] + coordinates[5][i] + coordinates[4][i] + coordinates[3][i]
          coordinates[4][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] + coordinates[5][i] + coordinates[4][i]
          coordinates[5][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] + coordinates[5][i]
          coordinates[6][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i] + coordinates[6][i] 
          coordinates[7][i] = coordinates[9][i] + coordinates[8][i] + coordinates[7][i]
          coordinates[8][i] = coordinates[9][i] + coordinates[8][i] 
        }
        return([top10ClientName,uniqueClientDate,coordinates])
      }

      function getConsultantPerCountryHist(consultants){
        const consultantPerCountryData = _.groupBy(consultants, 'sageContent.filiale.country')
        const consultantPerCountryHist = _.map(Object.keys(consultantPerCountryData), function(country){
          return {"Variable" : country, "Count" : consultantPerCountryData[country].length}
        })
        return consultantPerCountryHist
      }

      function getConsultantsDomainHist(consultants){
        let countRailway = 0
        let countEnergy = 0
        let countRailwayAndEnergy = 0
        _.forEach(consultants,function(consultant){ 
          let domain = consultant.environnement['environnement-domain']
          if (domain.Railway>0){
            countRailway = countRailway + 1
          }
          if (domain.Energy>0){
            countEnergy = countEnergy + 1
          }
          if(domain.Energy>0 && domain.Railway>0){
            countRailwayAndEnergy = countRailwayAndEnergy + 1
          }
        })
        return(
          {
            "Variable" : ["Railway","Energy", "Railway And Energy"], "Count" : [countRailway,countEnergy,countRailwayAndEnergy]
          }
        )
      }


      function getProjectsTypologyhistThisYear(projects,year,year2){ 
          const ONE_YEAR_IN_MILLISECONDS = 31536000000;
          const currentDate = new Date();
          const currentDateInMilliseconds = currentDate.getTime();
          const typologyThisYearHist = _.map(projects,function(project){
            if (project.content.information && project.content.information["start-date"]){
              const dateParts = project.content.information["start-date"].split("/");
              const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
              const dateInMilliseconds = dateObject.getTime();
              const differenceInMilliseconds = currentDateInMilliseconds - dateInMilliseconds;              
              if(differenceInMilliseconds < year*ONE_YEAR_IN_MILLISECONDS && differenceInMilliseconds > year2*ONE_YEAR_IN_MILLISECONDS ){
                return project.content.information.typology ;
              }
            }
            return null 
          });
          const projectsTypologyGroupBy =  _.groupBy(typologyThisYearHist)
          const projectsTypologyhist = _.map(Object.keys(projectsTypologyGroupBy),function(typology){
            return {"Variable" : typology, "Count" : projectsTypologyGroupBy[typology].length}
          })
          return (projectsTypologyhist.filter((item) => item.Variable !== 'undefined'))
      }


      function getConsultantsSeniorityHist(consultants,dataToChart){
        const consultantsSeniority = _.map(dataToChart,function(consultant){
          return consultant.seniority ;
        });
        const consultantsSeniorityGroupBy = _.groupBy(consultantsSeniority);
        const consultantsSeniorityHist = _.map(Object.keys(consultantsSeniorityGroupBy),function(seniority){
          return {"Variable" : seniority, "Count": consultantsSeniorityGroupBy[seniority].length}
        })
          return consultantsSeniorityHist
      }


      const consultants = _.map(this.props.datatochart,function(consultant){return consultant.content});
      const users = _.map(this.props.datatochart,function(consultant){return consultant.user});
      const projects = _.map(this.props.datatochart,function(consultant){return consultant.projects}).flat();
      const consultantPerCountryHist = getConsultantPerCountryHist(users);
      const consultantTotal = getConsultantTotal(consultants);
      const consultantsDomainHist = getConsultantsDomainHist(consultants);
      //const consultantsContextHist = getConsultantsContextHist(consultants);
      //const projectsTypologyhist = getProjectsTypologyhist(projects);
      const projectsTypologyhistThisYear = getProjectsTypologyhistThisYear(projects,this.state.typologyYear,this.state.typologyYear2);
      const consultantsSeniorityHist = getConsultantsSeniorityHist(consultants,this.props.datatochart);
      const formoption = this.props.formoption;

        let operationalSkills = consultants.map((consultant) => consultant['intervention-level']).filter((skill) => skill !== undefined).flat()
    
      let operationalSkillOrderedHist = [];

      const types = formoption.operational['intervention-type']
      _.forEach(types,function(type){
        const count = _.filter(operationalSkills,function(skill){return skill['intervention-type'] === type}).length
        const missions = formoption.operational['intervention-mission'][type] ? formoption.operational['intervention-mission'][type] : []
        _.forEach(missions,function(mission){
            const count = _.filter(operationalSkills,function(skill){return skill['intervention-mission'] === mission}).length
            const applications =  formoption.operational['intervention-application'][mission] ? formoption.operational['intervention-application'][mission] : []
            _.forEach(applications,function(application){
                const count = _.filter(operationalSkills,function(skill){return skill['intervention-application'] === application}).length
                operationalSkillOrderedHist.push({"Variable_lvl_00" : "","Variable_lvl_01" : "","Variable_lvl_02": application, "Count": count })
            })
            operationalSkillOrderedHist.push({"Variable_lvl_00" : "","Variable_lvl_01": mission,"Variable_lvl_02":"", "Count": count})
        })
        operationalSkillOrderedHist.push({"Variable_lvl_00": type, "Variable_lvl_01" : "","Variable_lvl_02" : "" ,"Count": count})
      })
      

        let technicalSkills = consultants.map((consultant) => consultant['expertise']).filter((skill) => skill !== undefined ).flat()


      //technical skill
      let technicalSkillOrderedHist = []
      const competences = formoption.technical['domain-competence']['Railway'].concat(formoption.technical['domain-competence']['Energy'])
      _.forEach(competences,function(competence){
        const count = _.filter(technicalSkills,function(skill){return skill['domain-competence'] === competence}).length
        const specialities = formoption.technical['domain-speciality'][competence] ? formoption.technical['domain-speciality'][competence] : []
        _.forEach(specialities,function(speciality){
            const count = _.filter(technicalSkills,function(skill){return skill['domain-speciality'] === speciality}).length
            const specificities =  formoption.technical['domain-specificity'][speciality] ? formoption.technical['domain-specificity'][speciality] : []
            _.forEach(specificities,function(specificity){
                const count = _.filter(technicalSkills,function(skill){return skill['domain-specificity'] === specificity}).length
                technicalSkillOrderedHist.push({"Variable_lvl_00" : "","Variable_lvl_01" : "","Variable_lvl_02": specificity, "Count": count})
            })
            technicalSkillOrderedHist.push({"Variable_lvl_00" : "","Variable_lvl_01": speciality,"Variable_lvl_02":"" , "Count": count})
        })
        technicalSkillOrderedHist.push({"Variable_lvl_00": competence, "Variable_lvl_01" : "","Variable_lvl_02" : "" ,"Count": count})
      })

      function createLinkNodeGraph(lvl,node){
        if (lvl === 0 ){
          return({ source: "Ikos", target: node, key:"Ikos" })
        }
        if (lvl === 1 ){
          let domain = ["Signalling","Rolling Stock","Infrastructure","High Voltage","Low Voltage","monitoring & control and instrumentation","Transmission And Distribution","Equipment and facilities","Fluid Mechanics"]
          let ref = [["ERTMS", "CBTC", "Interlocking (IXL)", "National Systems", "PTC", "Supervision"],
          ["Electrical System", "Vehicule Sub-systems", "Control and information systems", "Train systems", "Embedded systems", "Automatisation", "Embedded software", "Carbody", "Mecanical"],
          ["Civil Engineering", "Hydraulics", "Aménagement", "Railroad", "Metallic Structures"],
          ["Catenary", "Catenaryless", "Captation", "Protection Relays", "Sub-Stations"],
          ["IP / Networks", "Radio / Wireless", "Wired Transmissions", "Operational support systems", "IOT (Internet of Things)", "Supervision", "Ticketing/Access Control", "FireSafety", "Building Management System (BMS) / Centralised Technical Management system (CTMS) /CCTV", "SCADA / Supervision", "Anti-intrusion system / Access Controle / CCTV"],
          ["SNCC / Automatisme", "Instrumentation"],
          ["Low Voltage (LV) & High Voltage (HV) Distribution", "Medium Voltage (MV)", "Electrical Protection", "Digital Control Systems (DCS)", "Smart Grid", "Conversion"],
          ["Special Machines / Hoisting / Handling", "Valve", "Rotating Machines", "Piping", "Pressure Equipment", "Electro-mechanical Equipment"],
          ["Electromagnetism", "Thermal Dissipation", "Fluid Dynamics"]]
          for(let i = 0; i<ref.length; i++){
            if(ref[i].includes(node)){
              return({ source: domain[i], target: node, opacity:0.32, key:domain[i]+i })
            }
          }
        }
        /*if (lvl === 2 ){
          let domain = ["ERTMS","CBTC","Interlocking (IXL)","National Systems","Supervision","Electrical System","Vehicule Sub-systems",
          "Control and information systems","Train systems","Embedded systems","Automatisation","Embedded software","Carbody","Mecanical",
          "Civil Engineering","Aménagement","Railroad","Catenary","Catenaryless","Captation","Sub-Stations","IP / Networks","Radio / Wireless",
          "Wired Transmissions","Operational support systems","Supervision","Ticketing/Access Control"]
          let ref = [["Track", "ETCS ( European Train Control System)", "RBC (Radio Block Center)", "EVC (European Vital Computer", "UNISIG (Groupe de travail consitué d'entreprises sur l'ETCS)", "TSI(Technical Specification for Interoperability)", "N1", "N2", "N3", "Baseline 3", "On-board"],
          ["Track", "ATS (Automated Train Supervision)", "ATO  (Automated Train Operations)", "ATC  (Automated Train Control)", "PCC (Poste de Commande Centralisé)", "Data Communication Network", "ATP (Automatic Train Protection)", "On-board"],
          ["Manual block", "Computerized switch"],
          ["Track circuits, Croco, KVB, TVM", "Axle counters", "Bi-Standard"],
          ["ATS", "MISTRAL", "SCADA"],
          ["Traction", "Battery", "Bus and embedded network", "Electrical cabling & Apparatus", "Elecrtomagnetic comptability and grounding", "Dead Man's Switch"],
          ["Doors System", "Brake System", "Air production (HVAC)", "Diesel Power Pack", "Toilets System"],
          ["TCMS (Train Control Monitoring System)", "PAPIS (Passenger Announcement & Passenger Information System", "ATESS (Acquisition, Processing of Security Events through Statistics)", "Traction control system "],
          ["Train System", "Bogies", "Running dynamic", "Traction system", "Auxiliaries"],
          ["Automatic Vehicle Location (AVL)", "Real time passenger info (RTPI)", "Automatic Train Control (ATC)", "Command and control racks", "UC cards", "Communication routers", "Driver HMIs", "Train Protection and Warning System (TPWS)"],
          ["SAET", "Maggaly", "VAL"],
          ["Formal methods", "Modeling and Analysis of Real Time and Embedded systems (MARTE)", "Specification and Description Language (SDL)", "Architecture Analysis and Design Language (AADL)", "Structured Analysis for Real Time (SART)"],
          ["Carbody structure", "structure calculation ( modeling by finite element analysis)", "Welding/materials", "Crash"],
          ["Acoustics and Vibration", "Aerodynamics", "Structural Mechanics and Crash Safety", "Gauging, Movements, Dynamics", "Weight Reduction"],
          ["Engineering structures", "Underground structures", "Stations", "Maintenance Sites", "Plateforms", "Renewal of track and ballast", "Renewal of track apparatus", "Longitudinal profile", "Cross section profile", "Temporary speed restrictions"],
          ["Architecture", "Roads and Utilities infrastructure", "Railway Crossing"],
          ["Gauges", "Track Ballast", "Ballastless track", "Suites rapides", "Switches and Crossings", "Continuous Welded Rail"],
          ["25kV AC Catenary", "1,500 V DC Catenary", "Overhead contact line"],
          ["Ground-Based Static", "Onboard Power Cells", "Induction-loop (PrIMoVe)"],
          ["Pantograph collectors", "Bow collectors", "Trolley Poles"],
          ["HESOP"],
          ["GPR-S", "LTE (Long Term Evolution)", "Wifi"],
          ["GSM (Global System for Mobile Communications)", "Radio", "TETRA", "GSM-R", "RST ( Radio Sol Train)", "WIMAX", "LTE", "GPRS ,UMTS, Déploiement Radio"],
          ["Transmission", "Copper", "Powerline", "SDH (Synchronous Digital Hierachy)", "FTTH", "PDH", "fiber optics", "Gigabit Ethernet"],
          ["Passenger information and operational support system (SAEIV)", "Spacing support system (SAEE)"],
          ["Train Treatability and Diagnostics (TTDS)", "NAGIOS", "Panorama"],
          ["Passenger information and operational support system (SAEIV)", "RTPI (Real time passenger info)", "Operational support system (OSS)", "Audio system", "Fire safety system (SIS)"]]
          for(let i = 0; i<ref.length; i++){
            if(ref[i].includes(node)){
              return({ source: domain[i], target: node, opacity:0.001 ,key:domain[i]+i })
            }
          }
        }*/

      }

      function gettypologieByYearLinearCoordinate(){
        let label = [_this.props.translate(`content.extract.dashboard.chart.typology.Expertise & Assistance technique`),
                    _this.props.translate(`content.extract.dashboard.chart.typology.Work Package`),
                    _this.props.translate(`content.extract.dashboard.chart.typology.Pôles de compétences techniques`),
                    _this.props.translate(`content.extract.dashboard.chart.typology.Innovation`)]
        let Xaxis = [[],[],[],[]]
        let dateaxis = []
        let dateSample = new Date().getFullYear() - 2007
        for(let i = 0; i < dateSample + 1 ; i++){
          let typo = getProjectsTypologyhistThisYear(projects,i+1,i)
          for (let x = 0; x < typo.length; x++){
            if(typo[x].Variable === "Expertise & Assistance technique"){
              Xaxis[0].push(typo[x].Count)
            }
            if(typo[x].Variable === "Work Package"){
              Xaxis[1].push(typo[x].Count)
            }
            if(typo[x].Variable === "Pôles de compétences techniques"){
              Xaxis[2].push(typo[x].Count)
            }
            if(typo[x].Variable === "Innovation"){
              Xaxis[3].push(typo[x].Count)
            }
          }
          dateaxis.push(2007 + dateSample - i)
          //Xaxis.push(thisyeartypo)
        }
        //reverseXaxis + completed Axis if lack elements
        let maxLenght = 0
        for (let i = 0; i < Xaxis.length; i++){
          if (Xaxis[i].length > maxLenght){
            maxLenght = Xaxis[i].length
          }
        }
        for (let i = 0; i<Xaxis.length; i++){
          while (Xaxis[i].length<maxLenght){
            Xaxis[i].push(0)
          }
        }
        for(let i = 0; i < Xaxis.length; i++){
          Xaxis[i].reverse()
        }

        const sortedLabelArray = [...label].sort();
        let sortedXaxis = Array.from({ length: sortedLabelArray.length }, () => []);
        for(let i = 0; i < sortedLabelArray.length; i++){
          let oldIndex = label.indexOf(sortedLabelArray[i]);
          sortedXaxis[oldIndex]=Xaxis[i]
        }
        return([sortedLabelArray,dateaxis.reverse(),sortedXaxis,"chartTypologie"])
      }



      function renderNodeGraphic(zoomIsNear){
        let total = 0
        let nodes = []
        let r = 10
        let x = 0
        let y = 0
        let links = []
        let link = []
        let nodeColor = "blue"
        let opacity = 1
        let countlvl1 = 0
        let countlvl2 = 0
        let mat1X = 150
        let mat2X = 25
        let mat1Y = 25
        let mat2Y = -50
        //for each skill, create if needed a node and a link
        for(let i = 0; i <technicalSkillOrderedHist.length; i ++){
          total = total + technicalSkillOrderedHist[i].Count
          if(technicalSkillOrderedHist[i].Count>0){
            y = y + 1
            x = 0
            let id = technicalSkillOrderedHist[i].Variable_lvl_00
            if (id.length === 0){
              id = technicalSkillOrderedHist[i].Variable_lvl_01
              x = 1
              if (id.length === 0){
                id = technicalSkillOrderedHist[i].Variable_lvl_02
                x = 2
              }
            }
            r = 10 + 1.2*technicalSkillOrderedHist[i].Count
            if (r>49){
              link = createLinkNodeGraph(x,id)
              if (link){
                links.push(link)
              }
            }
            if (x === 0){
              opacity = 1
              nodeColor = "rgba(160,32,101,255)"
              //coordinate
              mat1Y = mat1Y + 50
              countlvl1 = countlvl1 + 1
              if (countlvl1>6){
                mat1X = 450
                if(countlvl1===7){
                  mat1Y = 1
                }
              }
            }
            if(x === 1){
              nodeColor = "rgba(40,44,47,255)"
              opacity = 0.55
              //coordinate
              mat2Y = mat2Y + 20
              countlvl2 = countlvl2 + 1
              if (countlvl2>34){
                mat2X = 575
                if(countlvl2===35){
                  mat2Y = -50
                }
              }
            }
            /*if(x===2){
              nodeColor = "black"
              opacity = 0.00000001
              //coordinate
              mat3Y = mat3Y + 15
              countlvl3 = countlvl3 + 1
              if (countlvl3>76){
                mat3X = 750
                if(countlvl3===77){
                  mat3Y = -75
                }
              }
            }*/
            if (zoomIsNear>1.45) {
              opacity = 1
            }
            //push final node configuration
            if (x === 0 && r>49){
              nodes.push({id: id, size: r, color: nodeColor,label:id +" ("+technicalSkillOrderedHist[i].Count+")", opacity:opacity , key:i, lvl:x, x:mat1X , y:mat1Y })
            }
            if (x === 1 && r>49){
              nodes.push({id: id, size: r, color: nodeColor,label:id +" ("+technicalSkillOrderedHist[i].Count+")", opacity:0.55 , key:i, lvl:x, x:mat2X , y:mat2Y })
            }
            /*if (x === 2){
              nodes.push({id: id, size: r, color: nodeColor,label:id +" ("+technicalSkillOrderedHist[i].Count+")", opacity:0.000000000000000001 , key:i, lvl:x, x:mat3X , y:mat3Y  })
            }*/
          }
        }
        nodes.push({id: "Ikos", size: (10 + 1.2*total)/2, color: "rgba(10,131,175,255)",label:"Ikos "+total, key:-1, x:326,y:192 })
        for (let i = 0; i< links.length; i++){
          links.source = nodes[links.source] 
          || (nodes[links.source] = {name: links.source});

          links.target = nodes[links.target] 
          || (nodes[links.target] = {name: links.target});
        }
        const linksUnique = links.filter((obj, index, self) =>
          index === self.findIndex((t) => (
            t.key === obj.key && t.source === obj.source && t.target === obj.target
          ))
        );
        const nodedata = {
          nodes: nodes,
          links: linksUnique,    
          labelProperty: 'label',
          renderLabel: true,
          focusedNodeId: "nodeIdToTriggerZoomAnimation",
        };
        return ( nodedata )
      }


      //en travaux
      function changeOpacity (nodeId) {
        /*let {nodes, links} = this.state.data;
        let adjacentNodes = links.filter (link => link.source === nodeId || link.target === nodeId)
          .map (link => link.source === nodeId ? link.target : link.source);
        for (let node of adjacentNodes) {
          let nodeObj = nodes.find (n => n.id === node);
          nodeObj.opacity = 1;
        }
        this.setState ({data: {nodes, links}});*/
      }



      function redrawGraph(opacity){      
        const newDiv = document.createElement("div");
        const newContent = document.createElement("div");
        newContent.setAttribute ('id', 'nodeGraph');
        ReactDOM.render(
          <div id="nodeGraph">
            <Graph
              id="graph-id"
              data={renderNodeGraphic(opacity)}
              config={myConfig}
            />
          </div>,
          newContent
        );
        newDiv.appendChild(newContent);
        document.getElementById("target").appendChild(newDiv);
        //return(false)
      }





      //-------------------------------------------
      let sortedData = technicalSkillOrderedHist.sort((a, b) => b.Count - a.Count);      
      let technicalSkillOrderedLvl1 = []
      let i = -1
      let nameCheck = []

      function testElement(element){
        return element === sortedData[i].Variable_lvl_00
      }

      while(technicalSkillOrderedLvl1.length < 5){
        i = i + 1
        if(sortedData[i].Variable_lvl_00.length > 0){
          if(  nameCheck.find(testElement) === false  ){
            nameCheck.push(sortedData[i].Variable_lvl_00)
            technicalSkillOrderedLvl1.push(sortedData[i])
          }
        } else {
          technicalSkillOrderedLvl1.push(sortedData[i])
        }
      }




      function switchHandler(graphicType){
        if (graphicType === "Somme") {
          return("Normal")
        } else {
          return("Somme")
        }
      }


      function RenderCountryPerContinent(countryList,X,Y){

        let continentList = [ ["Europe","Amérique du nord","Afrique","Asie"],[0,0,0,0] ]
        for(let i = 0; i < countryList.length; i++){
          if(countryList[i].Variable==="France" || countryList[i].Variable==="Belgique" || countryList[i].Variable==="Espagne" || countryList[i].Variable==="Angleterre" || countryList[i].Variable==="Italie" || countryList[i].Variable==="Allemagne" || countryList[i].Variable==="Suisse" || countryList[i].Variable==="Royaume-Uni" || countryList[i].Variable==="Suède" || countryList[i].Variable==="Italy" ) {
            continentList[1][0] = continentList[1][0] + countryList[i].Count
          }
          if (countryList[i].Variable==="Canada" || countryList[i].Variable==="États-Unis" || countryList[i].Variable==="Etats-Unis" ){
            continentList[1][1]=continentList[1][1]+countryList[i].Count
          }
          if(countryList[i].Variable==="Maroc"){
            continentList[1][2]=continentList[1][2]+countryList[i].Count
          }
          if(countryList[i].Variable==="Israel"){
            continentList[1][3]=continentList[1][3]+countryList[i].Count
          }
        }
        let total = 0
        for (let i = 0; i < continentList[1].length; i++){
          total = total + continentList[1][i]
        }
        total = total/100
        return(
          continentList[X][Y]
        )
      }


      function radarIkos(consultants,type){

        let business = 0
        let innovation = 0
        let management = 0
        let training = 0
        let context = 0
        let engineering = 0
        let operational = 0
        let technical = 0
        _.forEach(consultants,function(consultant){
          if (consultant.content.implication){
            let imp = consultant.content.implication
            if (imp.Business){
              business = business + imp.Business.length
            }
            if (imp.Innovation ){
              innovation  = innovation + imp.Innovation.length
            }
            if (imp.Management ){
              management  = management + imp.Management.length
            }
            if (imp.Training ){
              training = training + imp.Training.length
            } 
            if (imp.context ){
              context  = context  + imp.context.length
            } 
            if (imp.engineering ){
              engineering  = engineering  + imp.engineering.length
            } 
            if (imp.operational ){
              operational  = operational  + imp.operational.length
            } 
            if (imp.technical ){
              technical  = technical  + imp.technical.length
            } 
          }
        })
        let data = []
        if(type==="implication"){
          data = {
            labels:[_this.props.translate('content.implication.Business.title'),
                    _this.props.translate('content.implication.Innovation.title'),
                    _this.props.translate('content.implication.Training.title'),
                    _this.props.translate('content.implication.Management.title')],
            datasets:[{
              label:"implication",
              data:[business,innovation,training,management],
              fill: true,
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              borderColor: 'rgb(255, 99, 132)',
              pointBackgroundColor: 'rgb(255, 99, 132)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgb(255, 99, 132)'
            }]
          }
        }
        if(type === "ingineer"){
          data = {
            labels:["business","innovation","training","management"],
            datasets:[{
              label: 'engineer',
              data: [context, engineering, operational, technical],
              fill: true,
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgb(54, 162, 235)',
              pointBackgroundColor: 'rgb(54, 162, 235)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgb(54, 162, 235)'
            }]
          }
        }

        const options = {
          plugins: {
            tooltip: {
              enabled: true,
            },
          },
          scales: {
            r: {
              min:0,
              ticks: {
                display: false,
              },
            },
          },
        };

        return(
          <Radar
            options = {options}
            data={data}
          />
          )
      }


      function pieChartDataTypologie(){
        let labelArray = []
        let dataArray = []
        let total = 0
        for(let i = 0; i < projectsTypologyhistThisYear.length; i++){
          if(projectsTypologyhistThisYear[i].Variable.length > 0){
            total = total + projectsTypologyhistThisYear[i].Count
          }
        }
        for(let i = 0; i < projectsTypologyhistThisYear.length; i++){
          if(projectsTypologyhistThisYear[i].Variable.length > 0){
            labelArray.push(_this.props.translate(`content.extract.dashboard.chart.typology.${projectsTypologyhistThisYear[i].Variable}`) + "(" + (100*projectsTypologyhistThisYear[i].Count/total).toString().slice(0, 2)  + "%)")
            dataArray.push(projectsTypologyhistThisYear[i].Count)
          }
        }
        
        const sortedLabelArray = [...labelArray].sort();
        const sortedDataArray = sortedLabelArray.map((label) => dataArray[labelArray.indexOf(label)]);

        const dataStructure = {
          labels: sortedLabelArray,
          datasets: [
            {
              label: '# of Votes',
              data: sortedDataArray,
              backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(54, 162, 235, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              borderWidth: 1,
            },
          ],
        };
        return(dataStructure)
      }

      function createDataDomain(){
        const dataStructure = {
          labels: consultantsDomainHist.Variable,
          datasets: [
            {
              label: '# of Votes',
              data: consultantsDomainHist.Count,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              borderWidth: 1,
            },
          ],
        };
        return(dataStructure)
      }




      function foundCityListFrance(consultants){
        let Nantes = 0
        let AixEnProvence = 0
        let Lyon = 0
        let Paris = 0
        let Marseille = 0
        let Toulouse = 0
        let Lille = 0
        _.forEach(consultants,function(consultant){
          if (consultant.user.sageContent.filiale.city === "Nantes"){
            Nantes = Nantes + 1
          }
          if (consultant.user.sageContent.filiale.city === "Aix-en-Provence"){
            AixEnProvence = AixEnProvence + 1
          }
          if (consultant.user.sageContent.filiale.city === "Lyon"){
            Lyon = Lyon + 1
          }
          if (consultant.user.sageContent.filiale.city === "Paris"){
            Paris = Paris + 1
          }
          if (consultant.user.sageContent.filiale.city === "Marseille"){
            Marseille = Marseille + 1
          }
          if (consultant.user.sageContent.filiale.city === "Toulouse"){
            Toulouse = Toulouse + 1
          }
          if (consultant.user.sageContent.filiale.city === "Lille"){
            Lille = Lille + 1
          }
        })
        return([Nantes,AixEnProvence,Lyon,Paris,Marseille,Toulouse,Lille])
      }

      function renderBarGender(consultants) {
        const seniorityLevels = ["Expert","Senior","Confirmed","Medium","Junior"];
        let seniorityGender = [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0]];
      
        _.forEach(consultants, function(consultant) {
          const genderIndex = consultant.user.sageContent.profile.gender === "Male" ? 0 : 1;
          const seniorityIndex = seniorityLevels.indexOf(consultant.seniority);
      
          if (seniorityIndex !== -1) {
            seniorityGender[genderIndex][seniorityIndex] += genderIndex === 0 ? 1 : -1;
          }
        });
      
        return (
          <BarGender data={[seniorityLevels, seniorityGender]} param={["params"]} />
        );
      }

      function createVgraphic(consultants,top10Client){
        const label = ["System Requirements","Project Management","System Requirements","RAMS","Development and Realization","V&V",
        "Qualification","Concept & System Definition","Maintenance"]
        const bestClient = top10Client[0]
        let dataMetier = [0,0,0 ,0,0,0 ,0,0,0]
        let countClient = [ [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] ,
        [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] , 
        [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] , [0,0,0 ,0,0,0 ,0,0,0] ]
        _.forEach(consultants,function(consultant){
          const metier = consultant.content["intervention-level"]
          const myClient = consultant.clients
          _.forEach(metier,function(type){
            if(type["intervention-type"] === label[0]) { 
              dataMetier[0]=dataMetier[0]+1 
            }
            if(type["intervention-type"] === label[1]) { 
              dataMetier[1]=dataMetier[1]+1 
            }
            if(type["intervention-type"] === label[2]) { 
              dataMetier[2]=dataMetier[2]+1
            }
            if(type["intervention-type"] === label[3]) { 
              dataMetier[3]=dataMetier[3]+1
            }
            if(type["intervention-type"] === label[4]) { 
              dataMetier[4]=dataMetier[4]+1 
            }
            if(type["intervention-type"] === label[5]) { 
              dataMetier[5]=dataMetier[5]+1 
            }
            if(type["intervention-type"] === label[6]) { 
              dataMetier[6]=dataMetier[6]+1 
            }
            if(type["intervention-type"] === label[7]) { 
              dataMetier[7]=dataMetier[7]+1 
            }
            if(type["intervention-type"] === label[8]) { 
              dataMetier[8]=dataMetier[8]+1 
            }
          })
          // --- 2nd graph ---
          _.forEach(myClient,function(client){ 
            if(bestClient.includes(client)){
              const index = bestClient.indexOf(client)
              _.forEach(metier,function(competence){ 
                if(competence["intervention-type"] !== ""){
                  if(label.indexOf(competence["intervention-type"]) !== -1){
                    countClient[index][ label.indexOf(competence["intervention-type"]) ] = countClient[index][ label.indexOf(competence["intervention-type"]) ] + 1
                  }
                }
              })
            }
          })
        })
        const dataset = [
          {
            label: _this.props.translate("content.extract.dashboard.chart.graphic.nbProjectPerSkill") ,
            data:dataMetier,
            backgroundColor: 'rgba(0, 255, 0, 0.2)',
            borderColor: 'rgb(0, 255, 0)',
          }
        ]

        // --- turning data 2nd graph to %
        let sumOfAllClient = []

        countClient = countClient[0].map((_, colIndex) =>
          countClient.map((row) => row[colIndex])
        );

        for(let i = 0; i < bestClient.length; i++){
          sumOfAllClient.push( countClient.reduce((acc, arr) => acc + arr[i], 0) )
        }
        _.forEach(countClient, (value, index) => {
          for(let i =0; i < countClient[index].length; i++){
            countClient[index][i] = (countClient[index][i]/sumOfAllClient[i])*100
          }
        })
        //
        let dataSetClient = []
        const backgroundColor = ['rgba(0, 255, 0, 0.5)','rgba(255, 99, 132, 0.5)','rgba(53, 162, 235, 0.5)',
        'rgba(60, 60, 60, 0.5)','rgba(120, 120, 120, 0.5)','rgba(238, 130, 238, 0.5)',
        'rgba(255, 10, 10, 0.5)','rgba(10, 10, 255, 0.5)','rgba(2553, 214, 80, 0.5)'
        ]
        _.forEach(countClient, (value, index) => {
          dataSetClient.push(
            {
              label: _this.props.translate(['intervention-type'] +"." + label[index]),
              data:value,
              backgroundColor: backgroundColor[index],
            }
          )
        })
        let labelWithTranslation = []
        _.forEach(label, (value, index) => {
          labelWithTranslation.push( _this.props.translate(['intervention-type'] +"." + label[index] ) )
        })

        return(
          <div>
            {_this.props.translate("content.extract.dashboard.chart.sectionV")}
            <br></br>
            <Center>
              <div style={imageStyle}>
                <img src={diagramV} alt="a driagram in V shape" />
                {textPositions.map((position, index) => (
                  <div
                    key={index}
                    style={{
                      ...textOverlayStyle,
                      top: `${position.y}px`,
                      left: `${position.x}px`,
                    }}
                  >
                    <Paper shadow="xl" style={{  border: '1px solid black' }} >
                      <Text size="xs" c="dimmed" fw={700} >
                        <Space w="md" />  
                          { _this.props.translate(['intervention-type'] +"." + label[index] ) }
                        <Space w="md" />
                      </Text>
                    </Paper>
                  </div>
                ))}
              </div>
            </Center>
            <br></br>
            <BarChart data={ [labelWithTranslation,dataset] } param={[ _this.props.translate("content.extract.dashboard.chart.graphic.competence") , _this.props.translate("content.extract.dashboard.chart.graphic.nbProject") , _this.props.translate("content.extract.dashboard.chart.graphic.title1")]} /> 
            <br></br>
            <br></br>
            <BarChart data={ [bestClient,dataSetClient] } param={[ _this.props.translate("content.extract.dashboard.chart.graphic.client") , _this.props.translate("content.extract.dashboard.chart.graphic.competence%") , _this.props.translate("content.extract.dashboard.chart.graphic.title2") ,100]} />
          </div>
        )
      }

      

    return(
      <>
      <>
        {(styles) => 
          <div style={styles}>
            {/*
              <Affix position={{ bottom: rem(20), left: rem(20) }}>
                <Button
                  onClick={() => document.getElementById("root").scrollIntoView({behavior: 'smooth'})  }
                >
                  Défiler vers le haut
                </Button>
              </Affix>
            */}
          </div>}
      </>

      <Divider my="sm" />
      <h2>{this.props.translate("content.extract.dashboard.consultant")}{" "+consultantTotal}</h2>


      <Grid>
        <Grid.Col span={4}>
          <div id="Répartition par domaine">
            <Text fw={500}> {this.props.translate("content.extract.dashboard.chart.domainDistribution") + " :"}</Text>
            <Space h="xs" />
            <PieChart data={createDataDomain()} options={PieChartOptionsDomain} /> 
            <Space h="xs" />
            <Paper shadow="xl" radius="lg" p="xl">
              <Text fw={500}> {this.props.translate("content.extract.dashboard.chart.continentDistribution") + " :"} </Text>
              <Space h="xs" />
              {continent.map((element,i) => (
                <div key={i}>
                  <br></br>
                  <div style={{ position: "relative" }}>
                    <Tooltip label={RenderCountryPerContinent(consultantPerCountryHist,1,i)}>
                      <Progress radius="xl" size="xl" ref={this.progressRef} value={RenderCountryPerContinent(consultantPerCountryHist,1,i)} {...props} />
                    </Tooltip>
                    <span
                      style={{
                        position: "absolute",
                        left: 5, 
                        top: "calc(50% - 2px)",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <Text fw={500} c="#36454F" >   {this.props.translate(`content.extract.dashboard.chart.continent.${RenderCountryPerContinent(consultantPerCountryHist,0,i)}`)}  </Text>
                    </span>
                  </div>
                </div>
              ))}




            </Paper>
          </div>
        </Grid.Col>
        <Grid.Col span={8}>
          <div id="Répartition géographique">
            <Space h="xs" />
            <MapChart data={consultantPerCountryHist} city={foundCityListFrance(this.props.datatochart)} translate={this.props.translate} />
          </div>
        </Grid.Col>

        <Grid.Col span={this.state.graphConsultantOverTimeSize}>
          <div id="Graphique Consultant">
            <Text fw={500}>
              <ActionIcon variant="filled" aria-label="Settings">
                <IconArrowsMaximize onClick={() => this.setState({graphConsultantOverTimeSize : 12})} style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon> 
            </Text>
            <Space h="xs" />
            <LineChart data={this.props.datatochart} translate={this.props.translate}/>
          </div>
        </Grid.Col>


        <Grid.Col span={12}>
          <br></br>
          <div id="top10">
            <Space h="xs" />
            <> {`${this.props.translate('content.extract.dashboard.chart.changeGraphic')} :`} {this.props.translate(`content.extract.dashboard.chart.${this.state.graphicType}`)} </>
            <Switch
              onChange={() => this.setState({ graphicType : switchHandler(this.state.graphicType) })}
            />
            <br></br>
            <ClientChart data={getTop10ClientCoordinate(this.props.datatochart,this.state.graphicType)} />
          </div>
        </Grid.Col>


        <Grid.Col span={6}>
          <Space h="xs" />
          <Paper shadow="xl" radius="lg" p="xl">
            <div id="Experience">
              <Text fw={500}> {this.props.translate("content.extract.dashboard.chart.experience") + " :"}</Text>
              <Switch
                onChange={() => this.setState(prevState => ({
                  switchBarGraphMode: !prevState.switchBarGraphMode
                }))}
              />
              <Space h="xl" />
              {!this.state.switchBarGraphMode ? 
              <>
                <BarChartExperience
                  translate={this.props.translate}
                  data={consultantsSeniorityHist}
                  update={this.state.switchBarGraphMode}
                />
              </>
              :
              <>
                <div id="BarGender">
                  {renderBarGender(this.props.datatochart)}
                </div>
              </>
              }
            </div>
          </Paper>
        </Grid.Col>

        <Grid.Col span={6}>
          <div id="Radar">
            {radarIkos(this.props.datatochart,"implication")}
          </div>
        </Grid.Col>

        {/** bloc vue typology */}
        
        <Grid.Col span={12}>
          <Paper shadow="xl" radius="lg" p="xl">
            <div id="Typology">
              <Text fw={500}> {`${this.props.translate("content.extract.dashboard.chart.typology.title")} : `}  </Text>
              <Space h="md" />
              <Grid>
                <Grid.Col span={4}>
                  <PieChart data={pieChartDataTypologie()} options={PieChartOptionsDomain} translate={this.props.translate} />
                </Grid.Col>
                <Grid.Col span={8}>
                  <ClientChart data={gettypologieByYearLinearCoordinate()} />
                </Grid.Col>
              </Grid>
            </div>
          </Paper>
        </Grid.Col>

        <Grid.Col span={12}>
          <Paper shadow="xl" radius="lg" p="xl">
            {createVgraphic(this.props.datatochart,getTop10ClientCoordinate(this.props.datatochart,this.state.graphicType))}
          </Paper>
        </Grid.Col>
        
        <Grid.Col span={12}>
          <Paper shadow="xl" radius="lg" p="xl">
            <div id="target">
              <div id="nodeGraph">
                <Graph
                  id="graph-id"
                  ref={this.graphRef}
                  data={renderNodeGraphic(this.state.zoomIsNear)}
                  config={myConfig}
                  onZoomChange={this.onZoomChange}
                  //onClickNode={onClickNode}
                  onClickNode={changeOpacity}
                />
              </div>
            </div>
          </Paper>
        </Grid.Col>
      </Grid>
      {this.state.redrawGraph ?<> {redrawGraph()} </>:<></> }
      <br></br>
    </>)
  }

    
}
